import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Styles from "./DashboardRewardRedeem.module.css";
import { getRewardRedemedAction } from "../../../../store/actions/dashboard/DashboardActions";
import { useNavigate } from "react-router-dom";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";

const DashboardRewardRedeem = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { total_rewards_redeemed, loading, error } = useSelector((state) => state.dashBoardRewardRedeem);
  useEffect(() => {
    dispatch(getRewardRedemedAction({}, navigate));
  }, [dispatch]);

  if (loading) {
    return (
      <>
        <ShimmerLoader width='30%' height='10%' count={1} />
      </>
    );
  }
  if (!loading && total_rewards_redeemed) {
    return (
      <>
        {/* <div className='d-flex align-items-center border-0 px-3'>
          <div className='rounded-circle bg-primary d-flex  align-items-center justify-content-center' style={{ height: "48px", width: "48px" }}>
            <svg width='25' height='23' viewBox='0 0 25 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M6.63325 22.6667L4.99992 21.0333L13.0499 12.9542L17.1333 17.0375L23.1708 11L24.8333 12.6625L17.1333 20.3333L13.0499 16.25L6.63325 22.6667ZM2.66659 21.5C2.02492 21.5 1.47561 21.2715 1.01867 20.8146C0.561724 20.3576 0.333252 19.8083 0.333252 19.1667V2.83333C0.333252 2.19167 0.561724 1.64236 1.01867 1.18542C1.47561 0.728472 2.02492 0.5 2.66659 0.5H18.9999C19.6416 0.5 20.1909 0.728472 20.6478 1.18542C21.1048 1.64236 21.3333 2.19167 21.3333 2.83333V7.73333H2.66659V21.5ZM2.66659 5.4H18.9999V2.83333H2.66659V5.4Z' fill='#F6F6F6' />
            </svg>
          </div>
          <div className={`${Styles.statistics_number} d-block py-3 ps-4 align-items-center justify-content-center`}>
            <p>Total Sales</p>
            <p className='text-primary fs-4'>{total_rewards_redeemed.total_rewards_redeemed}</p>
          </div>
        </div> */}
        <div className='d-flex align-items-center border-0 px-3'>
          <div className='rounded-circle bg-primary d-flex  align-items-center justify-content-center' style={{ height: "48px", width: "48px" }}>
            <svg width='26' height='25' viewBox='0 0 26 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M2.6 13.75V16.25H23.4V13.75H2.6ZM2.6 0H23.4C24.115 0 24.7271 0.244792 25.2362 0.734375C25.7454 1.22396 26 1.8125 26 2.5V16.25C26 16.9375 25.7454 17.526 25.2362 18.0156C24.7271 18.5052 24.115 18.75 23.4 18.75H18.2V25L13 22.5L7.8 25V18.75H2.6C1.885 18.75 1.27292 18.5052 0.76375 18.0156C0.254583 17.526 0 16.9375 0 16.25V2.5C0 1.8125 0.254583 1.22396 0.76375 0.734375C1.27292 0.244792 1.885 0 2.6 0ZM2.6 10H23.4V2.5H2.6V10Z' fill='#F6F6F6' />
            </svg>
          </div>

          <div className={`${Styles.statistics_number} d-block py-3 ps-4 align-items-center justify-content-center`}>
            <p>Reward Redeemed</p>
            <p className='text-primary fs-4'>{total_rewards_redeemed?.total_rewards_redeemed?.toFixed(2)} gm</p>
          </div>
        </div>
      </>
    );
  }
};

export default DashboardRewardRedeem;
